import React from 'react';

import { Title } from 'Components/frameworks/title/Title';
import { Text } from 'Components/frameworks/text/Text';
import { classnames } from 'Utils/classnames/classnames.utils';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';

export const InspirationalDescription = ({ title, subtitle, description, centered }) => {
  const { isRTL } = useResponsive();

  if (!title && !subtitle && !description) {
    return null;
  }

  return (
    <div
      className={classnames('leading-1', {
        'mx-auto max-w-3/5 text-center sm:pb-95': centered,
        'direction-rtl': isRTL,
      })}
    >
      <Title theme="none" className="font-brand text-24" hLevel={3}>
        {title}
      </Title>
      <Text className="text-16 font-bold" text={subtitle} theme="none" />
      <Text className="text-16" text={description} theme="none" />
    </div>
  );
};
